import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Typography } from '@mui/material';

export const title = 'Processing historical data';
export const subtitle = 'Historical data takes time to process, but it’s worth it!';

// TODO: Use MUI theme helpers after update to MUI 6 -
// https://mui.com/material-ui/customization/container-queries/
export const containerQueryMaxHeight = '@container (max-height: 144px)';
export const containerQueryMinHeight = '@container (min-height: 144px)';

export function WidgetHistoricLoadingContent() {
  return (
    <Box
      sx={{
        ...flex.colCenter,
        [containerQueryMaxHeight]: {
          display: 'none',
        },
        '[role=tooltip] &': {
          alignItems: 'flex-start',
          display: 'block',
        },
      }}>
      <Typography
        sx={{
          color: 'var(--color-content-base-primary)',
          [`[role=tooltip] &`]: {
            color: 'inherit',
          },
        }}
        variant="h7">
        {title}
      </Typography>
      <div>{subtitle}</div>
    </Box>
  );
}
